import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { RailLinkProvider } from '../shared/ProgramTree/RailLink';
import SPARailLink from '../shared/ProgramTree/SPARailLink';
import LessonGuidesPage from './LessonGuides';
import LessonSectionsPage from './LessonSections';
import SectionCopyModal from './LessonSections/SectionCopyModal';
import SectionStatesModal from './LessonSections/SectionStatesModal';
import PrintToolsPage from './PrintTools';
import LessonStatesModal from './ProgramLessons/LessonStatesModal';
import ProgramEditPage, { NewProgramPage, programEditRoutes } from './ProgramEdit';
import ProgramLessonsPage from './ProgramLessons/ProgramLessonsPage';
import ProgramUnitsPage from './ProgramLessons/ProgramUnitsPage';
import SPAReuseLessonsModal from './ProgramLessons/SPAReuseLessonsModal';
import SharedProgramsModal from './ProgramLessons/SharedProgramsModal';
import programsPageRoutes from './programsPageRoutes';
import UnitEditPage, { unitEditRoutes } from './UnitEdit';

// AIDEV-NOTE: ContentView is the React Router shell for /admin/content.
// Each page manages its own breadcrumb internally.
// The Programs page routes (tabs and routed modals) live in programsPageRoutes, shared with the
// legacy /admin/programs mount, which routes the lessons, edit and new pages itself at its own
// paths. Rail links (the program tree, node tabs) render as router links throughout content view.
const ContentView = () => (
  <RailLinkProvider value={SPARailLink}>
    <Routes>
      {programsPageRoutes}
      <Route element={<NewProgramPage />} path="/programs/new" />
      <Route element={<ProgramLessonsPage />} path="/programs/:programId">
        <Route element={<SPAReuseLessonsModal />} path="reuse-lessons" />
        <Route element={<SharedProgramsModal />} path="lessons/:lessonId/shared-programs" />
        <Route element={<LessonStatesModal />} path="lessons/:lessonId/states" />
      </Route>
      <Route element={<LessonGuidesPage />} path="/programs/:programId/lessons/:lessonId/guides" />
      <Route element={<LessonSectionsPage />} path="/programs/:programId/lessons/:lessonId/sections">
        <Route element={<SectionCopyModal />} path=":sectionId/copy" />
        <Route element={<SectionStatesModal />} path=":sectionId/states" />
      </Route>
      <Route element={<PrintToolsPage />} path="/programs/:programId/lessons/:lessonId/print-tools" />
      <Route element={<LessonGuidesPage />} path="/programs/:programId/units/:unitId/guides" />
      <Route element={<ProgramUnitsPage />} path="/programs/:programId/units" />
      <Route element={<UnitEditPage />} path="/programs/:programId/units/:unitId/edit">{unitEditRoutes}</Route>
      <Route element={<ProgramEditPage />} path="/programs/:programId/edit">{programEditRoutes}</Route>
    </Routes>
  </RailLinkProvider>
);

export default ContentView;
